export default {"src":"/_next/static/media/aadhar_verification.79d24e42.svg","height":204,"width":206,"blurWidth":0,"blurHeight":0};